<div class="calendar-wrapper p-3">
  <div class="calendar-toolbar">
    <div class="nav-buttons">
      <button
        class="btn btn-outline-secondary btn-sm"
        mwlCalendarPreviousView
        [view]="view"
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
      >
        <i class="bi bi-chevron-left me-1"></i> Prev
      </button>

      <button class="btn btn-primary btn-sm" mwlCalendarToday [(viewDate)]="viewDate">Today</button>

      <button
        class="btn btn-outline-secondary btn-sm"
        mwlCalendarNextView
        [view]="view"
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
      >
        Next <i class="bi bi-chevron-right ms-1"></i>
      </button>
    </div>

    <h3 class="calendar-title mb-0">
      {{ viewDate | calendarDate: view + 'ViewTitle' : 'en' }}
    </h3>

    <div class="view-switcher nav-pills-modern">
      <button
        class="nav-link"
        (click)="setView(CalendarView.Month)"
        [class.active]="view === CalendarView.Month"
      >
        Month
      </button>

      <button
        class="nav-link"
        (click)="setView(CalendarView.Week)"
        [class.active]="view === CalendarView.Week"
      >
        Week
      </button>

      <button
        class="nav-link"
        (click)="setView(CalendarView.Day)"
        [class.active]="view === CalendarView.Day"
      >
        Day
      </button>
    </div>
  </div>

  <!-- Calendar Legend -->
  <div class="calendar-legend">
    <span class="legend-item"
      ><span class="legend-dot" style="background: #ef4444"></span>Booked</span
    >
    <span class="legend-item"
      ><span class="legend-dot" style="background: #3b82f6"></span>Ongoing</span
    >
    <span class="legend-item"
      ><span class="legend-dot" style="background: #f59e0b"></span>Pending</span
    >
    <span class="legend-item"
      ><span class="legend-dot" style="background: #6b7280"></span>Completed</span
    >
    <span class="legend-item todo-legend"
      ><span class="legend-dot" style="background: #15803d"></span>Todo Task</span
    >
  </div>

  <div class="calendar-view-container mt-3">
    @switch (view) {
      @case (CalendarView.Month) {
        <mwl-calendar-month-view
          [viewDate]="viewDate"
          [events]="events"
          (dayClicked)="dayClicked($event.day)"
          (eventClicked)="handleEventClick($event)"
        />
      }

      @case (CalendarView.Week) {
        <mwl-calendar-week-view
          [viewDate]="viewDate"
          [dayStartHour]="8"
          [dayEndHour]="18"
          (dayHeaderClicked)="dayHeaderClicked($event.day)"
          (hourSegmentClicked)="hourSegmentClicked($event.date)"
          (eventClicked)="handleEventClick($event)"
          [events]="events"
        />
      }

      @case (CalendarView.Day) {
        <mwl-calendar-day-view
          [viewDate]="viewDate"
          [dayStartHour]="8"
          [dayEndHour]="18"
          (eventClicked)="handleEventClick($event)"
          [events]="events"
        />
      }
    }
  </div>
</div>
